'use es6';

import { catchError } from 'rxjs/operators/catchError';
import { from } from 'rxjs/observable/from';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { of } from 'rxjs/observable/of';
import { startWith } from 'rxjs/operators/startWith';
import { tap } from 'rxjs/operators/tap';
import ContentRoutes from 'ContentUtils/Routes';
import { CONVERTED_CONTENT } from '../actions/ActionTypes';
import { closeModal } from '../actions/ModalActions';
import { requestConvertContent, requestedConvertContentFailure, requestedConvertContentSuccess } from '../actions/ContentActions';
import { getContentIsScheduledOrPublished } from '../selectors/contentSelectors';
import { completeOnboardingPublishTask } from '../utils/cmsOnboarding';
const sendToEdit = (id, categoryId) => {
  window.location.href = ContentRoutes.edit(id, categoryId);
};
export default ((action$, state$, {
  ContentClient
}) => action$.ofType(CONVERTED_CONTENT).pipe(mergeMap(({
  payload: {
    categoryId,
    contentType,
    id,
    newContentType
  }
}) => ContentClient.convertContent(contentType, id, newContentType).pipe(mergeMap(() => {
  const isScheduledOrPublished = getContentIsScheduledOrPublished(state$.getState());
  const endRequestObservable = of(closeModal(), requestedConvertContentSuccess(contentType, newContentType));
  if (isScheduledOrPublished) {
    return from(completeOnboardingPublishTask(newContentType)).pipe(mergeMap(() => endRequestObservable));
  }
  return endRequestObservable;
}), tap(() => sendToEdit(id, categoryId)), catchError(error => of(requestedConvertContentFailure(error, contentType, newContentType))), startWith(requestConvertContent())))));